<template>
  <div class="person-list" ondragstart="return false" oncontextmenu="return false">
    <ei-header :header-show="true" :header2-show="false" :header2-lit="header2Lit"></ei-header>
    <DropdownPluginWriter style="margin-left: 128px;position: absolute;margin-top: 600px"
                           :lieWidth="lieWidth" :lieHeight="lieHeight" :lieFontSzie="lieFontSzie" :lieMarginLeft="lieMarginLeft"
    >
    </DropdownPluginWriter>
    <DropdownPluginPainter style="margin-left: 1810px;position: absolute;margin-top: 600px"
                            :lieWidth="lieWidth" :lieHeight="lieHeight" :lieFontSzie="lieFontSzie" :lieMarginLeft="lieMarginLeft"
    >
    </DropdownPluginPainter>
    <ei-music  style="margin-top: 610px;margin-left: 186px;position: fixed"></ei-music>

    <ei-person-detail :person="person" :works-page="worksPage" @pageNumChange="pageNumChange"
                    ></ei-person-detail>
  </div>
</template>

<script>
import {
  queryPersonAction, queryWorksListAction, queryWorksPageAction, queryPersonByCoverArea, queryOneMusic,
} from '@/api/reception/works-api'
import {isFailure} from '@/eiuov-utils/axios/response'

export default {
  name: 'PageCalligrapher',
  data() {
    return {
      lieWidth:31,
      lieHeight:28,
      lieMarginLeft:-50,
      lieFontSzie:23,
      personName: '',
      person: {},
      worksPage: {
        list: [],
        total: 0,
        wordCountTotal: '00000',
        pageSize: 8,
        pageNum: 1,
      },
      header2Lit: false,
      titleButterflyImg: '/upload/homeBlock/1/titleButterflyImg.png',
      articleListImg: '/upload/homeBlock/1/articleListImg.png',
    }
  },
  created() {
    this.rowGuid = this.$route.query.guid
    this.initPage()
  },
  inject: ['reload'],
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    '$route'(to, from) {
      this.$set(this, 'name', to.query.name)
      this.reload()
    },
  },
  methods: {
    initPage() {
      this.initHeader()
      this.personName = this.$route.query.name
      queryPersonAction({personName: this.personName}).then((res) => {
        if (isFailure(res)) return
        this.person = res.data.person
      })
      queryWorksPageAction({
        personName: this.personName,
        pageNum: this.worksPage.pageNum,
        pageSize: this.worksPage.pageSize
      }).then((res) => {
        if (isFailure(res)) return
        this.worksPage.list = res.data.list
        this.worksPage.total = res.data.total
      })
    },

    initHeader() {
      window.addEventListener('mousewheel', this.handleScroll, true) || window.addEventListener('DOMMouseScroll', this.handleScroll, false)
    },
    handleScroll(e) {
      let direction = e.deltaY > 0 ? 'down' : 'up'
      if (direction === 'down') {
        setTimeout(() => {
          this.$set(this, 'header2Lit', false)
        }, 0)
      } else {
        setTimeout(() => {
          this.$set(this, 'header2Lit', true)
        }, 0)
      }
    },
    pageNumChange(pageNumNew) {
      this.worksPage.pageNum = pageNumNew
      queryWorksPageAction({
        personName: this.personName,
        pageNum: this.worksPage.pageNum,
        pageSize: this.worksPage.pageSize
      }).then((res) => {
        if (isFailure(res)) return
        this.worksPage.list = res.data.list
        this.worksPage.total = res.data.total
        this.worksPage.wordCountTotal = res.data.wordCountTotal
      })
    },
    toWorkDetail(rowGuid) {
      this.$router.push({
        path: '/WorksDetail',
        query: {guid: rowGuid}
      })
    },

  },
}

</script>


<style scoped lang="scss">

.person-list{
  width: 100%;
  overflow: hidden;
}
* img,span,a,div{
  user-select: none;
  -webkit-user-drag:none;
}
</style>
